import s from './ImageDivider.module.css';
import { ImageDividerProps } from '@/types/model';
import useIsMobile from '@/hooks/use-is-mobile';
import { ImageLoader } from '@/lib/imageLoader';
import Image from 'next/image';
import { motion } from 'framer-motion';

const ImageDivider = ({ imageDesktop, imageMobile }: ImageDividerProps) => {
  const isMobile = useIsMobile();
  return (
    <motion.div
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
      className={s.container}>
      <Image
        src={ImageLoader({ src: isMobile ? imageMobile?.url : imageDesktop?.url })}
        alt="imagen representativa"
        fill
        sizes="100vw"
        quality={65}
      />
    </motion.div>
  );
};

export default ImageDivider;
